import { render, staticRenderFns } from "./tdjl.vue?vue&type=template&id=81405b8a&scoped=true"
import script from "./tdjl.vue?vue&type=script&lang=js"
export * from "./tdjl.vue?vue&type=script&lang=js"
import style0 from "./tdjl.vue?vue&type=style&index=0&id=81405b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81405b8a",
  null
  
)

export default component.exports